import { useSnackbar } from '@app/snackbar'
import { useEffect, useRef } from 'react'

const loadingErrorHook = (
  fetchingData: boolean,
  onTimeout: () => void,
  timeoutMs = 15000,
  errorSnackbarText = 'Something went wrong. Please try again. If the problem persists, please contact Mapping Industries.',
  // Called at timeout time so the logged values reflect the state at failure
  getDebugInfo?: () => Record<string, unknown>
) => {
  const [openSnackbar] = useSnackbar()
  // Keep the latest callback so the timeout logs current values, not the
  // ones captured when fetching started
  const getDebugInfoRef = useRef(getDebugInfo)
  getDebugInfoRef.current = getDebugInfo
  useEffect(() => {
    let timeout: NodeJS.Timeout | null = null
    if (fetchingData) {
      const startedAt = Date.now()
      timeout = setTimeout(() => {
        console.error(
          `[loadingErrorHook] Fetching timed out after ${
            Date.now() - startedAt
          }ms`,
          getDebugInfoRef.current ? getDebugInfoRef.current() : undefined
        )
        openSnackbar(errorSnackbarText)
        onTimeout()
      }, timeoutMs)
    } else if (timeout) {
      clearTimeout(timeout)
    }
    return () => {
      if (timeout) {
        clearTimeout(timeout)
      }
    }
  }, [fetchingData])
}

export default loadingErrorHook
